module.exports = __webpack_public_path__ + "static/img/title.29ccf60c.png";